export default "__VITE_ASSET__820bc83e__"